import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/assets/css/AllCss.css'
import {createPinia} from "pinia";

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

//尝试 解决el-table 宽度变化谷歌浏览器报错问题
// const debounce = (fn:any, delay:any) => {
//   let timer:any = null;
//   return function (this:any) {
//     let context = this;
//     let args = arguments;
//     clearTimeout(timer);
//     timer = setTimeout(function () {
//       fn.apply(context, args);
//     }, delay);
//   }
// };
// const _ResizeObserver = window.ResizeObserver;
// window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
//   constructor(callback:any) {
//     callback = debounce(callback, 16);
//     super(callback);
//   }
// };


app.use(ElementPlus, {locale: zhCn,}).use(createPinia()).use(router).mount('#app');
